The date & time the relationship was added or removed. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
